import PropTypes from 'prop-types'
import { Spinner } from '@telus-uds/components-web'

import SpinnerContainer from './styles'

const FullPageSpinner = ({ tip }) => {
  return (
    <SpinnerContainer>
      <Spinner show={true} label={tip} />
    </SpinnerContainer>
  )
}

FullPageSpinner.propTypes = {
  tip: PropTypes.string.isRequired
}

export default FullPageSpinner
